// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"bbf3a315","142":"6a6a762d","214":"4cb3e809","279":"7a538dad","440":"60970645","787":"03a9611a"}[chunkId] + ".chunk.js";
};